import { useCallback, useState } from 'react';
import _ from 'lodash';
interface Errors {
  username: string;
}
const USERNAME_KEY = 'Details: Contact with';
const useParseContactError = () => {
  const [errors, setErrors] =useState<Partial<Errors>>({});

  const handleParseError = useCallback((e: unknown, values: object) => {
    const message = _.get(e, 'response.data.elevate_error_message', '');
    if(message.includes(USERNAME_KEY)) {
      setErrors({
        ...errors,
        username: _.get(values,'username')
      });
      return true;
    }
    return false;
  }, [errors]);
  return {
    handleParseError, errors
  };
};
export default useParseContactError;